import ReactGA from 'react-ga';

const trackingId = process.env.GOOGLE_ANALYTICS_TRACKER_ID;

export function gaTrackerInitialize() {
    ReactGA.initialize(trackingId);
}

export default function gaTrackerEvent(category, action, label = '') {
    ReactGA.event({
        category,
        action,
        label,
    });
}
